<template>
	<div class="p-6">
		<h1 class="text-2xl font-semibold text-gray-900 mb-6" v-if="hasH1">
			{{ __("Please select your favorite products") }}
		</h1>

		<ui-button-select
			class="grid-cols-3 md:grid-cols-5 lg:grid-cols-5"
			v-model="form.favorite_product_types"
			:options="favoriteProductOptions"
			:key="'favoriteProductOptions-' + favoriteProductOptions.length"
		/>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		gridCols: {
			type: String,
			default: "8",
		},
		hasH1: {
			type: Boolean,
			default: true,
		},
		defaultProducts: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			favoriteProductOptions: Object.values(
				this.$cropOptions.favoriteProductOptions
			)
				.flat()
				.map(function (o) {
					return { label: o.name, value: o.id, icon: o.id.toLowerCase() };
				}),
		};
	},
	created() {
		if (
			this.form.favorite_product_types.length == 0 &&
			this.defaultProducts != null
		) {
			this.form.favorite_product_types = this.defaultProducts;
		}
	},
};
</script>
